export const ANALYTICS_PLATFORM = 'web';

export enum AnalyticsApp {
  UNIFIED_SDK = 'unified_sdk',
  PAYMENT_SESSION_HANDLER = 'payment_session_handler',
  LRS_CHECKOUT_PAGE = 'lrs_checkout_page',
  CHECKOUT = 'checkout',
  KYC_APP = 'kyc_app',
  INVESTOR_PORTAL = 'investor_portal',
  MERCHANT_DASHBOARD = 'merchant_dashboard',
  KYC_SDK = 'kyc_sdk',
  CHECKOUT_SDK = 'checkout_sdk',
  S2S_PAYMENTS = 's2s_payments',
}

export enum AnalyticsProduct {
  CHECKOUT = 'checkout',
  KYC = 'kyc',
  DASHBOARD = 'dashboard',
  INVESTOR_PORTAL = 'investor_portal',
}

export enum AnalyticsJourney {
  STANDARD = 'standard',
  SUBSCRIPTION = 'subscription',
  LRS = 'lrs',
  NRI = 'nri',
  RESIDENT = 'resident',
}

export enum AnalyticsIntegration {
  WEB_DIRECT = 'web_direct',
  WEB_SDK = 'web_sdk',
  FLUTTER_SDK = 'flutter_sdk',
  IOS_SDK = 'ios_sdk',
  ANDROID_SDK = 'android_sdk',
  REACT_NATIVE_SDK = 'react_native_sdk',
}

export enum AnalyticsBankMode {
  GLOMO_MOCK = 'glomo_mock',
  BANK_SANDBOX = 'bank_sandbox',
  BANK_LIVE = 'bank_live',
}

export const DEVICE_TYPE = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile',
  TABLET: 'tablet',
} as const;
